import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import SearchForLaptop from './SearchForLaptop';
import { GetContainerDetailsInput } from 'src/models/GetContainerDetails';
import { fetchContainerDetails, resetContainerState } from 'src/store/common-slices/getContainerSlice';

const mapStateToProps = (state: RootState) => ({
    containerDetails: state.GetContainer.containerDetailsOutput,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => dispatch(fetchContainerDetails(getContainerDetailsInput)),
    resetContainerState: () => dispatch(resetContainerState())
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchForLaptop);
